import { ReactComponent as SearchGlyph } from '@/assets/images/svg/glyphs/search.svg';
import gtm from '@/lib/gtm';
import { COLORS } from '@/styles/color';
import { mediaBreakpointUp } from '@/styles/layout/utils';
import { FONT_FAMILIES, TEXT_SIZES } from '@/styles/typography';
import { remCalc } from '@/styles/typography/utils';
import { FC, FormEventHandler, useRef } from 'react';
import styled from 'styled-components';

const SearchFormWrapper = styled.form`
  position: relative;
  width: 100%;
  max-width: ${remCalc(880)};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: ${remCalc(6)};
  border-bottom: 2px solid ${COLORS.BLACK};

  ${mediaBreakpointUp('desktop')} {
    padding-bottom: 0;
  }
`;

const SearchField = styled.input`
  width: 100%;
  background: transparent;

  ${TEXT_SIZES[24]};
  font-family: ${FONT_FAMILIES.SERIF};
  color: ${COLORS.VIOLET.LOWLIGHT};
  outline: none;

  &::placeholder {  
  color: ${COLORS.VIOLET.LOWLIGHT};
  }

  ${mediaBreakpointUp('desktop')} {
    ${TEXT_SIZES[38]};
  }
`;

interface SearchFormProps extends PropsWithClassName {
  query?: string;
  onSearch?: (query: string) => void;
  onQueryUpdate?: (query: string) => void;
}

const SearchForm: FC<SearchFormProps> = (props) => {
  const searchInput = useRef<HTMLInputElement>(null);

  const onSearchSubmit: FormEventHandler = (event) => {
    event.preventDefault();

    const searchTerms = searchInput.current?.value || '';

    if (props.onSearch) {
      props.onSearch(searchTerms);

      gtm.track('search', {
        search_terms: searchTerms,
      });
    }
  };

  return (
    <SearchFormWrapper className={props.className} onSubmit={onSearchSubmit}>
      <SearchField
        ref={searchInput}
        placeholder="Search"
        value={props.query || ''}
        onInput={(event) => props.onQueryUpdate && props.onQueryUpdate((event.target as HTMLInputElement).value)}
      />
      <button type="submit">
        <SearchGlyph width={30} />
      </button>
    </SearchFormWrapper>
  );
};

export default SearchForm;
